<rask-div-list [data]="grupp.fragor">
  <rask-list-column header="Sekvensnummer" width="200px">
    <ng-template let-row="row">
      {{ row.sekvensnummer }}
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Beskrivning">
    <ng-template let-row="row">
      <a href="javascript: void(0)" (click)="onRowClick(row)">{{ row.beskrivning }}</a>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Aktiv">
    <ng-template let-row="row">
      @if (row.aktiv) {
        <i class="far fa-check"></i>
      }
    </ng-template>
  </rask-list-column>
</rask-div-list>
<div class="d-flex">
  <rask-button color="primary" negative (click)="onDeleteClick()">Ta bort grupp</rask-button>
</div>